import { useCallback, useEffect, useState } from "react";
import clinicAPI from "../../../services/clinicApi";
import ScheduleStepForm from "../AdminOnboarding/ScheduleStepForm";
import {
  addMinutesToTime,
  emptyScheduleDraft,
  slotsToEntries,
} from "../AdminOnboarding/scheduleStepUtils";
import s from "../clinic.module.css";
import { useToast } from "../../ui";

export default function GroupSchedulePanel({
  groupId,
  groupName,
  directionName,
}) {
  const toast = useToast();
  const [form, setForm] = useState(() => emptyScheduleDraft());
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const load = useCallback(async () => {
    if (!groupId) return;
    setLoading(true);
    try {
      const data = await clinicAPI.getGroupScheduleSlots(groupId);
      const entries = slotsToEntries(data.slots || []);
      setForm({
        ...emptyScheduleDraft(),
        entries,
        start_time: entries[0]?.start_time || "16:00",
        duration_min: entries[0]?.duration_min || 60,
      });
    } catch {
      setForm(emptyScheduleDraft());
    } finally {
      setLoading(false);
    }
  }, [groupId]);

  useEffect(() => {
    load();
  }, [load]);

  const save = async (e) => {
    e.preventDefault();
    const entries = form.entries || [];
    if (!entries.length) {
      toast.error("Добавьте хотя бы один слот в расписании");
      return;
    }
    setSaving(true);
    try {
      const res = await clinicAPI.saveGroupScheduleSlots(groupId, {
        slots: entries.map((entry) => ({
          weekday: entry.weekday,
          start_time: entry.start_time,
          end_time: addMinutesToTime(entry.start_time, entry.duration_min),
        })),
        generate_weeks: 8,
        regenerate_future: true,
      });
      toast.success(
        res.sessions_created
          ? `Расписание сохранено · ${res.sessions_created} занятий в календаре`
          : "Расписание сохранено",
      );
      await load();
    } catch (err) {
      toast.error(err.response?.data?.error || "Ошибка сохранения");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <p className={s.groupsHubScheduleHint}>Загрузка расписания…</p>;
  }

  return (
    <div className={s.groupsHubSchedulePanel}>
      <p className={s.groupsHubScheduleHint}>
        Изменение расписания отменит будущие занятия этой группы и создаст новые
        по шаблону на 8 недель вперёд.
      </p>
      <ScheduleStepForm
        form={form}
        onChange={setForm}
        onSubmit={save}
        saving={saving}
        submitLabel="Сохранить расписание"
        groupName={groupName}
        directionName={directionName}
        submitEnabled={(form.entries || []).length > 0}
      />
    </div>
  );
}
